<template>
    <div class="codelab-simulator-area" :class="{show: showSimulator}">
        <div class="trigger" :class="{active: showSimulator}" @click="toggleSimulator">
            <svg-icon href="#codelab-dashbord-simulator" :width="8" :height="16"></svg-icon>
        </div>
        <div class="simulator-container" v-show="showSimulator">
            <template v-if="currentVersion === 'family'">
                <nuwa-simulator v-if="!simulatorIs" />
                <template v-else>
                    <div :class="['simulator_static', shit$(`background-image: url(${env$}static/images/simulator_static.png);`)]"></div>
                    <section
                        :class="shit$(`w:100%; h:100%; z:1; absolute; top; left; object-fit:contain;`)">
                        <p :class="shit$(`font:18px; c:#fff; text-a:c; pt:333px;`)">{{this.$t( "code-lab/component/layout/simulator-area.vue_0" ) }}</p>
                        <p :class="shit$(`font:18px; c:#fff; text-a:c; mt:5px;`)" >{{this.$t( "code-lab/component/layout/simulator-area.vue_1" ) }}？</p>
                        <el-button :class="shit$(`dis:b; margin:auto; mt:20px; py:0px; miw:157px; px:10px; radius:4px; bgc:#00b5e2!; c:#fff!; border:none; hover:opacity:0.6; active:opacity:1;`)">
                            <span @click="exchange" :class="shit$(`dis:b; h:36px; lh:36px; font:16px!; font-w:normal; letter-s:1.07px; c:#fff;`)">{{this.$t( "code-lab/component/layout/simulator-area.vue_2" ) }}</span>
                        </el-button>
                    </section>
                </template>
            </template>
            <template v-else>
                <nuwa-simulator />
            </template>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import NuwaSimulator from '@/code-lab/component/machine-simulator/simulator.vue'
import { store as exchangeStore, mutations as exchangeutations } from '@/code-lab/component/exchange/observable.js'
export default {
    name: "simulator-area",
    components: {
        NuwaSimulator
    },
    computed: {
        ...mapState({
            env$: 'env$',
            showSimulator: "showSimulator",
            currentVersion: 'currentVersion'
        }),
        simulatorIs () { return exchangeutations.isEmpty('simulator') },
        simulator () { return exchangeStore.simulator }
    },
    watch: {
        'simulator.keys' (keys) {
            if (keys.length) {
                this.$nextTick(() => {
                    this.$store.commit("SHOW_SIMULATOR", true)
                })
            }
        }
    },
    methods: {
        exchange () {
            exchangeutations.type('simulator')
            if (!exchangeutations.isEmpty('simulator')) return
            this.$store.commit('SELECTEDMENUERIGHT', 'exchange') 
            exchangeutations.simulator({ show: true })
            this.$router.push({ path: "/exchange" })
        },
        toggleSimulator () {
            this.$store.commit("SHOW_SIMULATOR", !this.showSimulator)
        }
    },
    mounted() {
        this.$emit('simulatorUiEvent')
        // this.$nextTick(() => this.$store.commit("SHOW_SIMULATOR", true))
    },
}
</script>

<style lang="scss">
    .codelab-simulator-area{
        .simulator_static {
            width: 100%;
            height: 100%;
            background-size: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: top;
        }
        width: 32px;
        position: relative;
        overflow: hidden;
        &.show{
            width: 332px;
        }
        .trigger{
            position: absolute;
            width: 32px;
            height: 32px;
            left: 0;
            top: 15px;
            background: $--codelab-primary-black-2;
            pointer-events: all;
            line-height: 32px;
            text-align: center;
            cursor: pointer;
            svg{
                fill: $--codelab-primary-gray-2;
                stroke: $--codelab-primary-gray-2;
                transform-origin: center;
            }
            &.active{
                svg{
                    transform: rotate(180deg);
                }
            }
            &::before{
                content: "";
                display: block;
                position: absolute;
                top: -16px;
                width: 0;
                height: 0;
                border-bottom: 16px solid $--codelab-primary-black-2;
                border-left: 32px solid transparent;
            }
            &::after{
                content: "";
                display: block;
                position: absolute;
                top: 32px;
                width: 0;
                height: 0;
                border-top: 16px solid $--codelab-primary-black-2;
                border-left: 32px solid transparent;
            }
            &:hover{
                svg{
                    fill: $--codelab-primary-blue-1;
                    stroke: $--codelab-primary-blue-1;
                }
            }
        }
        .simulator-container{
            position: absolute;
            width: calc(100% - 32px);
            height: 100%;
            border-left: 4px solid $--codelab-primary-black-2;
            left: 32px;
            top: 0;
            pointer-events: all;
        }
    }
</style>